document.addEventListener("turbo:load", function() {
  const cityAutocomplete = document.querySelector("[data-js-id=js-job-city-field")
  const jobAutocomplete = document.querySelector("[data-js-id=js-job-term-field")

  $(jobAutocomplete).autocomplete({
    source: $(jobAutocomplete).data('autocomplete-source')
  }).autocomplete('widget').addClass('jobsearch');

  $(cityAutocomplete).autocomplete({
    source: $(cityAutocomplete).data('city-autocomplete-source')
  }).autocomplete('widget').addClass('citysearch');

});
